import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery } from '../../../services/process/BRS1/brsService7';
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import excelIcon from '../../../assets/images/excel.png';

function WhatsappFormResponses() {
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [searchText, setSearchText] = useState('');
  const [tabIndex, setTabIndex] = useState(0);

  const gridRef = useRef(null);

  const handleTabSelect = (index) => {
    setTabIndex(index);
  };

  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  useEffect(() => {
      if (tabIndex === 0) {
          fetchFormResponses();
      }
      if (tabIndex === 1) {
          fetchWhatsappResponses();
      }

  }, [tabIndex]);


  const fetchFormResponses = async () => {

      setLoading(true);
      setError(null);

      const payload = {
        query: `
          SELECT
              r.id AS response_id,

              MAX(CASE WHEN ra.question_id = 1135 THEN ra.answer_text END) AS first_name,
              MAX(CASE WHEN ra.question_id = 1136 THEN ra.answer_text END) AS last_name,
              MAX(CASE WHEN ra.question_id = 1137 THEN ra.answer_text END) AS program,
              MAX(CASE WHEN ra.question_id = 1138 THEN ra.answer_text END) AS education,
              MAX(CASE WHEN ra.question_id = 1139 THEN ra.answer_text END) AS semester,
              MAX(CASE WHEN ra.question_id = 1140 THEN ra.answer_text END) AS university,
              MAX(CASE WHEN ra.question_id = 1141 THEN ra.answer_text END) AS study_term,
              MAX(CASE WHEN ra.question_id = 1142 THEN ra.answer_text END) AS email,

              r.created_date

          FROM dynamic_form.responses r

          INNER JOIN dynamic_form.response_answers ra
              ON ra.response_id = r.id

          WHERE r.questionnaire_id = 70
          AND r.is_active = 1

          GROUP BY
              r.id,
              r.created_date

          ORDER BY
              r.id DESC;
          `
      };

      try {

          const creds = Fetchexecutequery();

          const response = await axios.post(
              creds[1],
              payload,
              creds[0]
          );

          const data = response.data;

          if (data.length > 0) {

              const columns = Object.keys(data[0]).map(key => ({
                  headerName: formatColumnName(key),
                  field: key,
                  sortable: true,
                  filter: true,
                  resizable: true
              }));

              setColumnDefs(columns);
              setRowData(data);

          } else {

              setColumnDefs([]);
              setRowData([]);

          }

      } catch (err) {

          console.log(err);
          setError("Unable to fetch form responses.");

      }

      setLoading(false);
    };
  const fetchWhatsappResponses = async () => {
    setLoading(true);
    setError(null);

    const payload = {
      query: `SELECT
    cs.primary_id AS session_id,
    cm.mobile,
    cm.customer_name,

    MAX(CASE WHEN cr.variable_name = 'program'
        THEN cr.response_value END) AS program,

    MAX(CASE WHEN cr.variable_name = 'education'
        THEN cr.response_value END) AS education,

    MAX(CASE WHEN cr.variable_name = 'semester'
        THEN cr.response_value END) AS semester,

    MAX(CASE WHEN cr.variable_name = 'university'
        THEN cr.response_value END) AS university,

    MAX(CASE WHEN cr.variable_name = 'study_term'
        THEN cr.response_value END) AS study_term,

    MAX(CASE WHEN cr.variable_name = 'email'
        THEN cr.response_value END) AS email,

    MAX(cr.created_at) AS submitted_at

FROM conversation_db.conversation_response cr

JOIN conversation_db.conversation_session cs
    ON cr.session_id = cs.primary_id

JOIN customer.customer_master cm
    ON cs.customer_id = cm.primary_id

WHERE cr.flow_id = 2

GROUP BY
    cs.primary_id,
    cm.mobile,
    cm.customer_name

ORDER BY
    cs.primary_id DESC;`
    };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
        }));

        setColumnDefs(columns);
        setRowData(data);
      } else {
        setColumnDefs([]);
        setRowData([]);
      }
    } catch (error) {
      console.error("Error fetching WhatsApp form responses:", error);
      setError("Error fetching WhatsApp form responses");
    }
    setLoading(false);
  };

  const downloadCsv = () => {
    if (!gridRef.current) return;

    gridRef.current.api.exportDataAsCsv({
      fileName: "whatsapp_form_responses.csv",
    });
  };

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };

  return (
    <>
      <LoaderComponent loaderOpen={loading} />

      <div>
        <h2
          className="pt-1 pb-1 text-center"
          style={{ color: "#0a2352", fontSize: "18px" }}
        >
          FORM RESPONSES
        </h2>

        <Tabs selectedIndex={tabIndex} onSelect={handleTabSelect}>
          <TabList>
            <Tab>Form</Tab>
            <Tab>WhatsApp</Tab>
          </TabList>

          {/* TAB 1 - FORM (placeholder) */}
          <TabPanel>

          <div style={{ padding: "10px" }}>

              {error && <div style={{ color: "red" }}>{error}</div>}

              <div
                  style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "10px"
                  }}
              >

                  <input
                      type="text"
                      placeholder="Search..."
                      value={searchText}
                      onChange={onFilterTextChange}
                      style={{
                          width: "320px",
                          padding: "8px"
                      }}
                  />

                  <img
                      src={excelIcon}
                      alt="Excel"
                      title="Export"
                      onClick={downloadCsv}
                      style={{
                          width: "30px",
                          height: "30px",
                          cursor: "pointer"
                      }}
                  />

              </div>

              <div
                  className="ag-theme-alpine"
                  style={{
                      width: "100%",
                      height: "500px"
                  }}
              >

                  <AgGridReact
                      ref={gridRef}
                      columnDefs={columnDefs}
                      rowData={rowData}
                      quickFilterText={searchText}
                      pagination
                      paginationPageSize={15}
                      defaultColDef={{
                          sortable: true,
                          filter: true,
                          resizable: true,
                          flex: 1,
                          minWidth: 150
                      }}
                  />

              </div>

          </div>

          </TabPanel>

          {/* TAB 2 - WHATSAPP */}
          <TabPanel>
            <div style={{padding: "15px 20px",width: "100%",boxSizing: "border-box",}}>
              {error && <div style={{ color: "red" }}>{error}</div>}

              {/* Search + Export Row */}
              {/* Search + Export */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "12px",
                  width: "100%",
                }}
              >
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchText}
                  onChange={onFilterTextChange}
                  style={{
                    width: "320px",
                    padding: "9px 12px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                />

                <img
                  src={excelIcon}
                  alt="Excel"
                  title="Export Excel"
                  onClick={downloadCsv}
                  style={{
                    width: "32px",
                    height: "32px",
                    cursor: "pointer",
                  }}
                />
              </div>

              {/* Grid */}
              <div
                className="ag-theme-alpine"
                style={{
                  width: "100%",
                  minWidth: "1400px",
                  height: "500px",
                  borderRadius: "8px",
                  overflow: "auto",
                }}
              >
                <AgGridReact
                  ref={gridRef}
                  columnDefs={columnDefs}
                  rowData={rowData}
                  quickFilterText={searchText}
                  pagination
                  paginationPageSize={15}
                  enableCellTextSelection={true}
                  suppressCopyRows={true}
                  defaultColDef={{
                    sortable: true,
                    filter: true,
                    resizable: true,
                    flex: 1,
                    minWidth: 170,
                  }}
                />
              </div>
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
}

export default WhatsappFormResponses;